import { Box, Stack, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

export function HeroSection() {
  return (
    <Box
      sx={{
        height: "40vh",
        minHeight: "400px",
        width: "100vw",
        display: "flex",
        alignItems: "stretch",
        background: "linear-gradient(to bottom right, #f5f5f5, #ffffff)",
        overflow: "hidden",
      }}
    >
      <Stack direction="row" sx={{ width: "100%", height: "100%" }}>
        {/* Left side */}
        <Box
          sx={{
            flex: 1,
            px: { xs: 2, md: 10 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            color="#1B2E85"
            sx={{ mb: 2 }}
          >
            Artificial Intelligence in Cancer Genetics
          </Typography>

          <Typography
            variant="body1"
            sx={{ mb: 3, maxWidth: 580, lineHeight: 1.3, fontSize: "1.1rem" }}
          >
            <strong>Genetic testing has become a commodity.</strong>
            <br />
            <br />
            The challenge now is managing carriers with strategies that reduce
            the morbidity and mortality of hereditary cancer. <br />
            <br />
            Using AI to guide clinical strategies in a Hereditary Cancer Clinic
            is the future of care.
          </Typography>

          <Button
            component={Link}
            to="/why-us"
            variant="outlined"
            sx={{
              color: "#1B2E85",
              borderColor: "#1B2E85",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "0.875rem",
              width: "fit-content",
              px: 2.5,
              py: 1,
              "&:hover": {
                backgroundColor: "#1B2E85",
                color: "white",
                borderColor: "#1B2E85",
              },
            }}
          >
            Learn More
          </Button>
        </Box>

        {/* Right side image */}
        <Box
          sx={{
            width: "auto",
            flexShrink: 0,
            display: { xs: "none", md: "flex" },
          }}
        >
          <Box
            component="img"
            src="heroimage1.png"
            alt="Doctors"
            sx={{
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
}

export function HeroSectionShorter() {
  return (
    <Box
      sx={{
        height: "40vh",
        minHeight: "250px",
        width: "100vw",
        display: "flex",
        alignItems: "stretch",
        background: "linear-gradient(to bottom right, #f5f5f5, #ffffff)",
        overflow: "hidden",
        pt: "80px",
      }}
    >
      <Stack direction="row" sx={{ width: "100%", height: "100%" }}>
        {/* Left side */}
        <Box
          sx={{
            flex: 1,
            px: { xs: 2, md: 4, xl: 8 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4" // Use "h4" for base sizing
            fontWeight="bold"
            color="#1B2E85"
            sx={{
              mb: 2,
              fontSize: { xs: "1.5rem", md: "2.2rem", xl: "3rem" }, // Responsive override
            }}
          >
            Artificial Intelligence in Cancer Genetics
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              maxWidth: 800,
              lineHeight: 1.5,
              fontSize: {
                xs: "1rem", // phones and very small tablets
                sm: "1.05rem", // small tablets and large phones
                md: "1.1rem", // laptops and small desktops
                lg: "1.15rem", // large screens
              },
            }}
          >
            <strong>Genetic testing has become a commodity. </strong>
            <br />
            The challenge now is managing carriers with strategies that reduce
            the morbidity and mortality of hereditary cancer. <br />
            Using AI to guide clinical strategies in a Hereditary Cancer Clinic
            is the future of care.
          </Typography>

          <Button
            component={Link}
            to="/why-us"
            variant="outlined"
            sx={{
              color: "#1B2E85",
              borderColor: "#1B2E85",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "0.875rem",
              width: "fit-content",
              px: 2.5,
              py: 1,
              "&:hover": {
                backgroundColor: "#1B2E85",
                color: "white",
                borderColor: "#1B2E85",
              },
            }}
          >
            Learn More
          </Button>
        </Box>

        {/* Right side image */}
        <Box
          sx={{
            width: "auto",
            flexShrink: 0,
            display: { xs: "none", md: "flex" },
          }}
        >
          <Box
            component="img"
            src="heroimage1.png"
            alt="Doctors"
            sx={{
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
}
